<style lang="less" scoped>
  .content {
    width: 100%;
  }
  .result-layout {
    width: 100%;
    text-align: center;
  }
  .table-container {
    width: 100%;
    height: 340px;
  }
  .table {
    width: 100%;
    height: 100%;
    text-align: left;
  }
  .table-col {
    height: 25%;
    width: 16.66%;
    border: 1px solid white;
    display: inline-block;
  }
  .match-number {
    height: 100%;
    flex: 1;
  }
  .arrow-row {
    padding: 16px 0;
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(@click-stop='redirectBack')
    .content
      .result-layout
        .up-arrow.arrow-row
          up-arrow-component(
            @click.native='prevPage'
            v-if='page > 0')
        .table-container
          .table
            .table-col(v-for='(data, key) in display')
              card-result-panel-component(
                :answer='data.answer'
                :input='data.input')
        .down-arrow.arrow-row
          down-arrow-component(
            @click.native='nextPage'
            v-if='page < groupCount - 1')
    .footer
      button-component(
        :text='"결과보기"'
        @click='done')
</template>

<script>
import HeaderComponent from '@/components/header/stop';
import ButtonComponent from '@/components/button';
import UpArrowComponent from '@/components/up_arrow';
import CardResultPanelComponent from '@/components/card_result_panel';
import DownArrowComponent from '@/components/down_arrow';

import GameType from '@/game';

export default {
  data() {
    return {
      page: 0,
      score: 0,
    };
  },
  methods: {
    addBestRecord(time, score) {
      const data = JSON.stringify({ time, score });
      this.$localStorage.set(this.localStorageKey, data);
    },
    loadBestScore() {
      const data = JSON.parse(this.$localStorage.get(this.localStorageKey));
      return this.$localStorage.get(this.localStorageKey) ? data : { score: 0, time: 0 };
    },
    done() {
      this.$router.replace({ name: 'Result' });
    },
    redirectBack() {
      this.$router.go(-1);
    },
    nextPage() {
      if (this.page + 1 < this.groupCount) {
        this.page += 1;
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page -= 1;
      }
    },
    getScore() {
      let score = 0;
      const answer = this.answer;
      const input = this.input;
      for (let i = 0; i < answer.length; i += 1) {
        if (answer[i].shape === input[i].shape && answer[i].card === input[i].card) {
          score += 1;
        } else {
          break;
        }
      }
      return score;
    },
    setBestRecord() {
      const best = this.loadBestScore();
      const score = this.score;
      const time = this.time;
      if (score < 52) {
        if (best.score < score) {
          this.addBestRecord(this.usedTime, this.score);
        }
      } else if (score >= 52) {
        if (best.time > time) {
          this.addBestRecord(this.usedTime, this.score);
        }
      }
    },
    addStoreBestScore() {
      const data = this.loadBestScore();
      this.$store.commit('setBestScore', data.score);
    },
    addStoreBestTime() {
      const data = this.loadBestScore();
      this.$store.commit('setBestTime', data.time);
    },
  },
  computed: {
    localStorageKey() {
      const arr = [GameType.mode.training, GameType.game.card, this.time];
      return arr.join('.');
    },
    time() {
      return this.$store.state.app.time;
    },
    display() {
      const result = [];
      const start = this.page * 24;
      const end = start + 24;
      for (let i = start; i < end; i += 1) {
        const answer = this.answer[i];
        const input = this.input[i];
        if (!this.answer[i]) {
          break;
        }
        result.push({ answer, input });
      }
      return result;
    },
    answer() {
      const result = [];
      const answer = this.$store.state.app.answer;
      for (let i = 0; i < answer.length; i += 1) {
        const data = answer[i];
        for (let j = 0; j < data.length; j += 1) {
          result.push(data[j]);
        }
      }
      return result;
    },
    input() {
      return this.$store.state.app.input;
    },
    groupCount() {
      return Math.ceil(this.answer.length / 24);
    },
    usedTime() {
      return this.$store.state.app.usedTime;
    },
    bestScore() {
      return this.$store.state.app.bestScore;
    },
    bestTime() {
      return this.$store.state.app.bestTime;
    },
    // score() {
    //   let score = 0;
    //   const answer = this.answer;
    //   const input = this.input;
    //   for (let i = 0; i < answer.length; i += 1) {
    //     if (answer[i].shape === input[i].shape && answer[i].card === input[i].card) {
    //       score += 1;
    //     } else {
    //       break;
    //     }
    //   }
    //   return score;
    // },
  },
  mounted() {
    this.score = this.getScore();
    this.$store.commit('setScore', this.score);
    if (this.score < 52) {
      // 52개가 아닌 경우에는 외우는 시간의 최대치를 기준으로 책정
      this.$store.commit('setUsedTime', this.time * 60);
    }
    this.setBestRecord();
    this.addStoreBestScore();
    this.addStoreBestTime();
  },
  components: {
    HeaderComponent,
    ButtonComponent,
    UpArrowComponent,
    CardResultPanelComponent,
    DownArrowComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/card/result.vue